import { Component, OnInit, Input, Output, ViewChild, ElementRef } from '@angular/core';

import * as ent from '../../entities/index'
import * as filters from '../../filters/index'
import * as serv from '../../services/index'


//components
import {MessageHandlerComponent} from '../Controls/MessageHandler.component';
import {BlockComponent} from '../Controls/Block.component';


@Component({
  selector: 'my-import-audit-grid',
  templateUrl: './ImportAuditGrid.component.html'
})
export class ImportAuditGridComponent implements OnInit {

    @ViewChild(MessageHandlerComponent) messageHandlerComponent: MessageHandlerComponent;
    @ViewChild(BlockComponent) blockComponent: BlockComponent;

    userInfo: ent.UserInfo;
    records: ent.ImportAudit[];
    
    constructor(private adminService: serv.AdminService, private authenticationService: serv.AuthenticationService) { 
    }

    ngOnInit(): void {
        this.userInfo = this.authenticationService.getUserInfo();
        this.onSearchClick(null);
    }

    public onSearchClick(event: any){
        this.blockComponent.blocked = true;
        
        let request: ent.GetDataRequest = {Employee: this.userInfo.Employee};
        this.adminService.getImportAudits(request).subscribe(x=>{
            this.records = x;
            this.blockComponent.blocked = false;
        }, err => {
            this.messageHandlerComponent.handleResponse({Success: false, ValidationMessages: [{Category: "error", MessageText: err}]})
            this.blockComponent.blocked = false;
        });
    }
}
    